/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';
import { ListGroup } from 'react-bootstrap';

export const AuthorImageStyle = {
  width: 50,
  height: 50,
};

export const ListGroupItem = styled(ListGroup.Item)`
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  }
`;
